import ScheduleExceptionsList from './ScheduleExceptionsList';

export default {
  ScheduleExceptionsList,
};
